/* bb-swap.js: Beyond Bohemian "Swap this stone" drawer (staged 2026-10-05).
   Loaded with defer, only on product pages that print a [data-bb-swap] trigger.
   The drawer's markup is built here and its data is fetched on first open from
   sections/bb-swap-feed.liquid, so the product page HTML carries only the trigger.
   Two modes, set by the trigger: "swap" (bulk pieces, any of the five bulk forms, in
   five size groups, with an uncapped set builder) and "similar" (one-of-one pieces of
   the same stone, no set).
   2026-10-13 (Paul's review of Phase 1): sizes grouped Mini to Extra Large, form chips
   to switch between tumbled, raw, points, palm stones and chips, tiles styled like the
   product cards (Title Case grade, size, region and country), "piece" instead of
   "stone", 13 color families for the dots, and a set with no cap plus a tier ladder. */
(function () {
  'use strict';

  /* ---- bbTrack: the one helper for every bb_ event (shoppability/tracking-plan.md) ---- */
  var GA4 = 'G-DRN79K8LS7';
  try { if (/[?&]bb_debug=1/.test(location.search)) sessionStorage.setItem('bb_debug', '1'); } catch (e) {}
  function debugOn() { try { return sessionStorage.getItem('bb_debug') === '1'; } catch (e) { return false; } }
  if (typeof window.bbTrack !== 'function') {
    window.bbTrack = function (name, params) {
      try {
        var p = {};
        Object.keys(params || {}).forEach(function (k) {
          var v = params[k];
          if (v === '' || v == null) return;
          p[k] = typeof v === 'number' ? v : String(v).slice(0, 100);
        });
        if (debugOn()) { p.debug_mode = true; console.log('[bbTrack]', name, p); }
        // Shopify's supported channel: any pixel can subscribe.
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, p);
        // GA4 through the Google tag already on the page. Delete this line if a custom pixel ever forwards bb_ events.
        if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ send_to: GA4 }, p));
      } catch (e) {}
    };
  }

  if (window.__bbSwapInit) return;
  var trigger = document.querySelector('[data-bb-swap]');
  if (!trigger) return;
  window.__bbSwapInit = true;
  // The theme editor re-renders the product section, so always look the button up fresh.
  function trig() { return document.querySelector('[data-bb-swap]') || trigger; }
  // A browser without <dialog> (Safari before 15.4, Firefox before 98) gets the filtered collection page instead.
  if (!(typeof HTMLDialogElement === 'function' && 'showModal' in HTMLDialogElement.prototype)) {
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bb-swap]');
      if (!t) return;
      e.preventDefault();
      location.href = (t.getAttribute('data-feed') || '').replace(/section_id=bb-swap-feed&?/, '');
    });
    return;
  }

  var cfg = trigger.dataset;
  var MODE = cfg.bbSwap === 'similar' ? 'similar' : 'swap';
  var HANDLE = cfg.h || '';
  var FORM = cfg.form || '';
  var KIND = cfg.kind || '';               // decor category key from snippets/bb-decor-cat (heart, diffuser, lamp ...)
  // Decor is a category drawer: a diffuser page offers the other diffusers, a heart the other hearts,
  // bulk or one of one, with category chips instead of form chips and no size groups (Paul, 14 Oct 2026).
  var DECOR = MODE === 'swap' && FORM === 'Polished Crystals & Decor';
  var CAT_ORDER = ['heart', 'diffuser', 'lamp', 'incense', 'candle', 'sphere', 'mushroom', 'freeform', 'vase', 'coaster', 'block', 'slab', 'cube', 'point', 'stick', 'cabochon', 'geode', 'decor'];
  var CAT_LABEL = { heart: 'Hearts', diffuser: 'Diffusers', lamp: 'Lamps', incense: 'Incense Holders', candle: 'Candle Holders', sphere: 'Spheres', mushroom: 'Mushrooms', freeform: 'Free Forms', vase: 'Vases', coaster: 'Coasters', block: 'Blocks', slab: 'Slabs & Discs', cube: 'Cubes', point: 'Points & Towers', stick: 'Sticks & Wands', cabochon: 'Cabochons', geode: 'Geodes', decor: 'Other Decor' };
  var CAT_NOUN = { heart: ['heart', 'hearts'], diffuser: ['diffuser', 'diffusers'], lamp: ['lamp', 'lamps'], incense: ['incense holder', 'incense holders'], candle: ['candle holder', 'candle holders'], sphere: ['sphere', 'spheres'], mushroom: ['mushroom', 'mushrooms'], freeform: ['free form', 'free forms'], vase: ['vase', 'vases'], coaster: ['coaster set', 'coaster sets'], block: ['block', 'blocks'], slab: ['slab', 'slabs'], cube: ['cube', 'cubes'], point: ['point', 'points'], stick: ['stick', 'sticks'], cabochon: ['cabochon', 'cabochons'], geode: ['geode', 'geodes'], decor: ['piece', 'pieces'] };
  var HOME_BAND = cfg.band || '';
  // Wholesale customers do not get the set offer. The server prints #bb-wholesale-strip only for
  // customers tagged wholesale-approved, the same test assets/bb-quickshop.js and bb-cart.js use.
  // HEARTS (20 Oct 2026, Paul, r7k-hearts: "hide the heart set line until then"): the bag does not count
  // hearts toward Build a set yet (that change to the bb-set-discounts app ships from the Mac Mini). Until
  // it does, a one-size polished heart page (data-heart="1", printed by snippets/bb-swap-trigger.liquid)
  // gets no "Build a set" bar and no "Add to set" buttons; its drawer still lists the hearts with links.
  // FLIP BACK once the app counts hearts: change false to true on the next line. Nothing else changes.
  var HEARTS_IN_SET = false;
  var SET_ON = MODE === 'swap' && !document.getElementById('bb-wholesale-strip') && (!DECOR || KIND === 'heart') && (HEARTS_IN_SET || cfg.heart !== '1');   // decor one-offs have no set offer
  var PCT = (cfg.pct || '').replace(/[^0-9.]/g, '');
  var PCT_TEXT = (PCT || '[X]') + '%';
  // Set tiers: [pieces, percent off]. The percentages are the proposal shown to shoppers; the
  // discount itself is a separate Shopify automatic discount or function (not built yet).
  var TIERS = [[3, 10], [6, 15], [12, 20]];   // rungs moved 15 Oct 2026 (3, 6, 12 pieces)
  // TIERS mirrors DEFAULT_TIERS in the bb-set-discounts Function app; the bar only shows percentages while that discount is active.
  var TIERS_LIVE = true;   // the bb-set-discounts Function app applies these tiers in the bag and at checkout (live 14 Oct 2026)
  try { if (/[?&]bb_tiers=1/.test(location.search)) sessionStorage.setItem('bb_tiers', '1'); if (sessionStorage.getItem('bb_tiers') === '1') TIERS_LIVE = true; } catch (e) {}
  var SET_KEY = 'bb_swap_set';   // the set lives in localStorage for a week, so it survives leaving the page
  var NAV_KEY = 'bb_swap_nav';
  // Size groups by the midpoint of the stored inch range. "1-2 Inches" (mid 1.5) is Large,
  // "0.75-1.25" (mid 1.0) is Medium, "1.5-3" (mid 2.25) is Extra Large.
  var BUCKETS = [
    ['small', 'Small', 0, 0.95], ['medium', 'Medium', 0.95, 1.45],
    ['large', 'Large', 1.45, 1.85], ['xl', 'Extra Large', 1.85, 99]
  ];   // Mini folded into Small, 14 Oct 2026 (Paul: keep the size row to one line)
  function bucketOf(band) {
    var m = /^(\d+)-(\d+)$/.exec(band || '');
    if (!m) return '';
    var mid = (+m[1] + +m[2]) / 200;
    for (var i = 0; i < BUCKETS.length; i++) if (mid >= BUCKETS[i][2] && mid < BUCKETS[i][3]) return BUCKETS[i][0];
    return '';
  }
  function bucketLabel(key) { for (var i = 0; i < BUCKETS.length; i++) if (BUCKETS[i][0] === key) return BUCKETS[i][1]; return ''; }
  // Forms the shopper can switch between inside the drawer (hearts stay their own drawer)
  var FORMS = ['Tumbled Stones', 'Raw Crystals', 'Raw Crystal Points', 'Palm Stones', 'Crystal Chips'];
  var FORM_CHIP = { 'Tumbled Stones': 'Tumbled', 'Raw Crystals': 'Raw', 'Raw Crystal Points': 'Points', 'Palm Stones': 'Palm Stones', 'Crystal Chips': 'Chips' };
  // 30 stored color names fold into 14 families for the dots (Gold stays its own, Paul 13 Oct 2026)
  var FAMILY = {
    'Teal Green': 'Green', 'Emerald Green': 'Green', 'Olive Green': 'Green', 'Yellow-Green': 'Green', 'Chartreuse': 'Green', 'Olive': 'Green', 'Dark Green': 'Green',
    'Golden': 'Gold', 'Honey': 'Gold', 'Smoky Gray': 'Brown', 'Smoky': 'Brown', 'Silver': 'Gray', 'Peach': 'Orange', 'Cream': 'White',
    'Lilac': 'Purple', 'Rainbow': 'Multicolor', 'Multicolored': 'Multicolor'
  };
  var FAMILY_ORDER = ['Black', 'Gray', 'White', 'Clear', 'Brown', 'Red', 'Orange', 'Yellow', 'Gold', 'Green', 'Blue', 'Purple', 'Pink', 'Multicolor'];
  var FAMILY_HEX = {
    Black: '#2B2927', Gray: '#8F8F8C', White: '#FBFAF6', Clear: 'linear-gradient(135deg,#FFFFFF 0%,#DCE7EC 55%,#F6FAFB 100%)', Brown: '#7A5A3A',
    Red: '#A63A32', Orange: '#DE8A3E', Yellow: '#E2C24A', Gold: 'linear-gradient(135deg,#EAD27E 0%,#C9A227 55%,#9E7A1C 100%)', Green: '#5E8B5A', Blue: '#5B7FA6', Purple: '#8A6BB5', Pink: '#E6A9B8',
    Multicolor: 'conic-gradient(#C8584E,#E2C24A,#5E8B5A,#5B7FA6,#8A6BB5,#C8584E)'
  };
  function families(it) {
    var out = [];
    (it.col || []).forEach(function (c) { var f = FAMILY[c] || c; if (FAMILY_HEX[f] && out.indexOf(f) < 0) out.push(f); });
    return out;
  }
  // product-card style name: the clean title with the form words removed, so a combination
  // such as "Aquamarine Raw Crystals with Black Tourmaline" reads "Aquamarine with Black Tourmaline"
  var FORM_WORDS = /\s+(?:Hand Polished Stones|Polished Crystal Chips|Raw Crystal Chips|Raw Crystal Points|Raw Crystal Clusters|Mini Crystal Clusters|Crystal Clusters|Raw Crystal Blades|Raw Crystals|Raw Stones|Tumbled Stones|Tumble Stones|Palm Stones|Crystal Points|Crystal Chips)(?=\s|$)/g;
  function cleanName(it) {
    var t = (it.t || '').replace(FORM_WORDS, '').replace(/\s+Regular Grade$/, '').replace(/\s{2,}/g, ' ').trim();
    return t || it.n || '';
  }
  function gradeText(g) {
    if (!g) return '';
    if (/grade/i.test(g)) return g.replace(/\bgrade\b/i, 'Grade');
    return g + ' Grade';
  }
  // "5-20 Grams" reads "5 to 20 Grams", the same pill as the amount tiles
  function weightText(w) {
    w = (w || '').trim();
    if (!w) return '';
    return w.replace(/\s*[-\u2013]\s*/, ' to ').replace(/\bgrams?\b/i, 'Grams').replace(/\bpounds?\b/i, 'Pounds');
  }
  function weightIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '12'); svg.setAttribute('height', '12'); svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2'); svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
    var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle'); c.setAttribute('cx', '12'); c.setAttribute('cy', '5.5'); c.setAttribute('r', '2.5');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', 'M7.5 9h9l3 11.5h-15z');
    svg.appendChild(c); svg.appendChild(p);
    return svg;
  }
  function sizeText(s) {
    return (s || '').replace(/\s*inch(es)?\b/i, '\u2033').replace(/\s*-\s*|\s+to\s+/, '\u2013').replace(/"/g, '\u2033');
  }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var FORM_LABEL = {
    'Tumbled Stones': 'Tumbled stones', 'Raw Crystals': 'Raw crystals', 'Raw Crystal Points': 'Raw crystal points',
    'Palm Stones': 'Palm stones', 'Crystal Chips': 'Crystal chips'
  };
  function formLabel() { return DECOR ? (CAT_LABEL[st.cat] || 'Decor') : (FORM_LABEL[st.form] || st.form); }
  function formTag() { return DECOR ? 'Decor: ' + (CAT_LABEL[st.cat] || st.cat) : st.form; }   // for events
  function nounOf() { return DECOR ? (CAT_NOUN[st.cat] || ['piece', 'pieces']) : ['piece', 'pieces']; }

  /* ---- bb_swap_navigate: sent on the destination page, from a marker saved at tap time ---- */
  (function () {
    var raw;
    try { raw = sessionStorage.getItem(NAV_KEY); if (raw) sessionStorage.removeItem(NAV_KEY); } catch (e) { return; }
    if (!raw) return;
    try {
      var m = JSON.parse(raw);
      if (!(m && m.to === HANDLE && Date.now() - m.t < 30000)) return;
      var tries = 0;
      (function send() {   // the Google tag may not be defined yet when this script runs
        if (typeof window.gtag !== 'function' && tries++ < 16) return setTimeout(send, 250);
        window.bbTrack('bb_swap_navigate', {
          product_handle: HANDLE, crystal_form: m.form, size_band: m.band, ui_source: m.src,
          from_handle: m.from, tile_position: m.pos, filter_type: m.ft, filter_value: m.fv
        });
      })();
    } catch (e) {}
  })();

  /* ---- small helpers ---- */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k === 'hidden') n.hidden = !!v;
      else n.setAttribute(k, v === true ? '' : v);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  // the inch guide printed under each size group (the same on every form, so the groups read as a ladder)
  var SPAN = { small: 'under 1 in', medium: '0.75 to 1.50 in', large: '1 to 2 in', xl: '1.50 to 3 in' };
  function bucketSpan(key) { return SPAN[key] || ''; }
  function bandText(key) { return bucketLabel(key); }
  function bandParam(key) { return key || ''; }
  function plural(n) { return n + ' ' + (n === 1 ? nounOf()[0] : nounOf()[1]); }
  function money(cents, cur) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cur || 'USD', currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }
  }
  function imgAt(url, w) { return String(url).replace(/([?&]width=)\d+/, '$1' + w); }

  /* ---- state ---- */
  var data = null;        // feed of the form being shown {cur, hex, items}
  var feeds = {};         // form -> feed, fetched once per page view each
  var loading = {};       // form -> in-flight promise
  var catalog = {};       // handle -> item, across every form loaded (the set can mix forms)
  var st = { form: FORM, cat: KIND, band: '', intent: '', color: '', q: '', moreIntents: false, set: [], source: 'swap_button' };   // band '' = All sizes, the default
  var ui = null;          // DOM refs, built on first open
  var pushed = false;     // true while our history entry is on top
  var opens = 0;          // counts opens, so a slow feed cannot report a drawer that was already closed
  var opening = false;    // true while the stylesheet loads, so a double tap cannot open twice
  var settled = false;    // false until the slide-in has finished, so a double tap cannot close it or hit a tile
  var lastFocus = null;
  function saveSet() {
    try {
      var recs = st.set.map(function (h) { return catalog[h]; }).filter(Boolean).map(function (it) {
        return { h: it.h, n: it.n, t: it.t, f: it.f, s: it.s, b: it.b, g: it.g, c: it.c, r: it.r, p: it.p, pf: it.pf, v: it.v, img: it.img, i: it.i, col: it.col };
      });
      if (recs.length) localStorage.setItem(SET_KEY, JSON.stringify({ t: Date.now(), items: recs }));
      else localStorage.removeItem(SET_KEY);
    } catch (e) {}
  }
  function restoreSet() {
    if (MODE !== 'swap') return;
    try {
      var raw = localStorage.getItem(SET_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (!saved || !saved.items || Date.now() - saved.t > 7 * 864e5) { localStorage.removeItem(SET_KEY); return; }
      saved.items.forEach(function (it) {
        if (!(it && it.h && it.v)) return;
        if (!catalog[it.h]) catalog[it.h] = it;   // a fresh feed record replaces this when its form loads
        if (st.set.indexOf(it.h) < 0) st.set.push(it.h);
      });
    } catch (e) {}
  }
  restoreSet();
  // Pieces already in the bag count toward the set (15 Oct 2026, Paul: "if I go back into a different
  // product and start adding pieces, Build a Set is blank"). The bag is read from /cart.js whenever the
  // drawer opens and whenever the theme says the bag changed. Same rule as the discount Function: a
  // single piece is a variant titled "(1 Piece)".
  var bag = { n: 0, total: 0, items: [] };
  function loadBag(then) {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = 0, total = 0, items = [];
        (c && c.items || []).forEach(function (it) {
          // 20 Oct 2026: polished hearts sold as a similar piece count too, same as the discount Function
          if (!/\(1 Piece\)/i.test(it.variant_title || '') && !/polished-hearts/i.test(it.handle || '')) return;
          n += it.quantity; total += it.original_line_price || 0;
          items.push({ n: it.product_title || '', img: it.image || '', q: it.quantity, key: it.key, h: it.handle || '', p: it.original_price || 0 });
        });
        bag = { n: n, total: total, items: items };
        if (then) then();
      }).catch(function () { if (then) then(); });
  }
  function totalN() { return bag.n + st.set.length; }
  ['cart:updated', 'cart-drawer:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { loadBag(function () { if (ui && data && ui.dlg.open) renderSet(); }); });
  });

  /* ---- data ---- */
  function parseFeed(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector('script[data-bb-swap-feed]');
    if (!node) throw new Error('no feed');
    return JSON.parse(node.textContent);
  }
  function feedUrl(form) {
    if (MODE === 'similar' || !form || form === FORM) return cfg.feed;
    return cfg.feed.replace(/(crystal_form=)[^&]*/, '$1' + encodeURIComponent(form));
  }
  function fetchPage(n, form) {
    var url = feedUrl(form) + (n > 1 ? '&page=' + n : '');
    return fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.text(); })
      .then(parseFeed);
  }
  function load(form) {
    form = MODE === 'similar' ? FORM : (form || st.form);
    if (feeds[form]) { data = feeds[form]; return Promise.resolve(data); }
    if (loading[form]) return loading[form];
    loading[form] = fetchPage(1, form).then(function (first) {
      var rest = [];
      for (var n = 2; n <= (first.pages || 1); n++) rest.push(fetchPage(n, form));
      return Promise.all(rest).then(function (more) {
        more.forEach(function (m) { first.items = first.items.concat(m.items || []); });
        return first;
      });
    }).then(function (feed) {
      // Shopify ignores a filter it does not know, so check every item here rather than trust the URL.
      var seen = {};
      feed.items = (feed.items || []).filter(function (it) {
        if (seen[it.h]) return false;
        seen[it.h] = 1;
        if (MODE === 'similar') return it.o === 1 && it.h !== HANDLE && (!cfg.name || it.n === cfg.name);
        if (it.o === 1 || it.f !== form) return false;
        if (form === 'Polished Crystals & Decor') return !!it.k;   // every decor category; inBand keeps the one being shown
        return true;
      });
      feed.items.forEach(function (it) { catalog[it.h] = it; });
      if (MODE === 'similar') {
        feed.items.sort(function (a, b) { return (a.z || 0) - (b.z || 0) || (a.p - b.p); });
      } else {
        // the stone being viewed leads its own size
        feed.items.sort(function (a, b) { return (b.h === HANDLE) - (a.h === HANDLE); });
      }
      feeds[form] = feed;
      if (form === st.form) data = feed;
      return feed;
    }).catch(function (e) { loading[form] = null; throw e; });
    return loading[form];
  }
  function inForm() { return data ? data.items : []; }
  function inBand() {
    if (MODE === 'similar') return data.items;
    if (DECOR) return data.items.filter(function (it) { return it.k === st.cat; });
    if (!st.band) return data.items;   // "All sizes"
    return data.items.filter(function (it) { return bucketOf(it.b) === st.band; });
  }
  function visible() {
    return inBand().filter(function (it) {
      return (!st.intent || (it.i || []).indexOf(st.intent) > -1) && (!st.color || families(it).indexOf(st.color) > -1)
        && (!st.q || (cleanName(it) + ' ' + (it.n || '')).toLowerCase().indexOf(st.q) > -1);
    });
  }
  function bands() {
    if (DECOR) return [];
    var seen = {};
    data.items.forEach(function (it) { var k = bucketOf(it.b); if (k) seen[k] = 1; });
    return BUCKETS.map(function (b) { return b[0]; }).filter(function (k) { return seen[k]; });
  }
  function colorTally(list) {
    var c = {};
    list.forEach(function (it) { families(it).forEach(function (f) { c[f] = (c[f] || 0) + 1; }); });
    return FAMILY_ORDER.filter(function (f) { return c[f]; });
  }
  function tally(list, key) {
    var c = {};
    list.forEach(function (it) { (it[key] || []).forEach(function (v) { c[v] = (c[v] || 0) + 1; }); });
    return Object.keys(c).sort(function (a, b) { return c[b] - c[a] || (a < b ? -1 : 1); });
  }

  /* ---- drawer shell ---- */
  function build() {
    var title = el('h2', { class: 'bbsw__title', id: 'bbsw-title', text: MODE === 'similar' ? 'Similar pieces' : (DECOR ? 'Choose your ' + nounOf()[0] : 'Choose your crystal') });
    var sub = el('div', { class: 'bbsw__sub' });
    var close = el('button', { type: 'button', class: 'bbsw__x', 'aria-label': 'Close' }, [el('span', { 'aria-hidden': 'true', text: '\u00d7' })]);
    var forms = el('div', { class: 'bbsw__forms', role: 'toolbar', 'aria-label': 'Form', hidden: true });
    var sizes = el('div', { class: 'bbsw__sizes', role: 'toolbar', 'aria-label': 'Size', hidden: true });
    // each filter row is one Tab stop; arrow keys move inside it
    var chips = el('div', { class: 'bbsw__chips', role: 'toolbar', 'aria-label': 'Filter by intention', hidden: true });
    var dots = el('div', { class: 'bbsw__dots', role: 'toolbar', 'aria-label': 'Filter by color', hidden: true });
    var find = el('input', { type: 'search', class: 'bbsw__find', placeholder: 'Find a stone', 'aria-label': 'Find a stone by name', autocomplete: 'off', hidden: MODE === 'similar' });
    var count = el('div', { class: 'bbsw__n', role: 'status' });
    var clear = el('button', { type: 'button', class: 'bbsw__clear', text: 'Clear filters', hidden: true });
    var countRow = el('div', { class: 'bbsw__count' }, [count, clear]);
    var grid = el('ul', { class: 'bbsw__grid', role: 'list' });
    var body = el('div', { class: 'bbsw__body', tabindex: '-1' }, [forms, sizes, chips, dots, find, countRow, grid]);
    var kids = [el('header', { class: 'bbsw__head' }, [el('div', null, [title, sub]), close])];
    var setBar = null, slots = null, setTitle = null, setSub = null, cta = null, err = null, live = null;
    if (SET_ON) {
      slots = el('div', { class: 'bbsw__slots', hidden: true });
      slots.addEventListener('scroll', slotsOver, { passive: true });
      setTitle = el('b', { text: 'Build a set' });
      setSub = el('span');
      cta = el('button', { type: 'button', class: 'bbsw__cta' });
      err = el('div', { class: 'bbsw__err', role: 'alert', hidden: true });
      live = el('div', { class: 'bbsw__vh', role: 'status' });
      // the ladder: one track, a node per tier, filled as far as the pieces in the bag plus the new picks reach
      var lfill = el('i', { class: 'bbsw__lfill' });
      var lnodes = TIERS.map(function (t, i) {
        var node = el('span', { class: 'bbsw__lnode' }, [el('b', { text: String(t[0]) }), el('small', { text: t[1] + '% off' })]);
        node.style.left = ((i + 1) / TIERS.length * 100) + '%';
        return node;
      });
      var ladder = el('div', { class: 'bbsw__ladder', 'aria-hidden': 'true', hidden: !TIERS_LIVE }, [el('div', { class: 'bbsw__lwrap' }, [el('div', { class: 'bbsw__ltrack' }, [lfill])].concat(lnodes))]);
      // Before the list in the DOM so a keyboard or screen reader user reaches the set right after Close;
      // assets/bb-swap.css orders it to the bottom of the panel.
      setBar = el('div', { class: 'bbsw__set', role: 'group', 'aria-label': 'Your set' }, [el('div', { class: 'bbsw__setmsg' }, [setTitle, setSub]), cta, ladder, slots, err, live]);
      setBar._lfill = lfill; setBar._lnodes = lnodes;
      kids.push(setBar);
    }
    kids.push(body);
    var panel = el('div', { class: 'bbsw__panel' }, kids);
    var dlg = el('dialog', { class: 'bbsw', 'aria-modal': 'true', 'aria-labelledby': 'bbsw-title' }, [panel]);
    document.body.appendChild(dlg);
    ui = { dlg: dlg, panel: panel, setBar: setBar, lfill: setBar && setBar._lfill, lnodes: setBar && setBar._lnodes, live: live, sub: sub, close: close, find: find, forms: forms, sizes: sizes, chips: chips, dots: dots, count: count, clear: clear, grid: grid, body: body, slots: slots, setTitle: setTitle, setSub: setSub, cta: cta, err: err };

    close.addEventListener('click', function () { shut(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); shut(); });        // Escape
    dlg.addEventListener('click', function (e) { if (e.target === dlg && settled) shut(); });       // backdrop, once the sheet has settled
    clear.addEventListener('click', function () { st.intent = ''; st.color = ''; st.q = ''; find.value = ''; filtered('clear', ''); ui.body.focus({ preventScroll: true }); });
    var findTimer = null;
    find.addEventListener('input', function () {
      st.q = find.value.trim().toLowerCase();
      var n = renderGrid();
      renderSet();
      clearTimeout(findTimer);
      if (st.q) findTimer = setTimeout(function () { window.bbTrack('bb_swap_filter', base({ filter_type: 'search', filter_value: st.q, result_count: n })); }, 800);
    });
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.more) { st.moreIntents = !st.moreIntents; renderControls(); (ui.chips.querySelector('[data-more]') || ui.chips).focus({ preventScroll: true }); return; }
      var next = b.dataset.v === st.intent ? '' : b.dataset.v;
      if (next === st.intent) return;                       // "All intentions" with none chosen
      st.intent = next;
      filtered('intention', st.intent || 'all');
    });
    dots.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var nextc = b.dataset.v === st.color ? '' : b.dataset.v;
      if (nextc === st.color) return;                       // "All colors" with none chosen
      st.color = nextc;
      filtered('color', st.color || 'all');
    });
    chips.addEventListener('keydown', rove);
    dots.addEventListener('keydown', rove);
    forms.addEventListener('keydown', rove);
    sizes.addEventListener('keydown', rove);
    function dropStaleFilters() {
      // a filter that no piece in the new size carries would leave an empty grid, so drop it
      var list = inBand();
      if (st.intent && tally(list, 'i').indexOf(st.intent) < 0) st.intent = '';
      if (st.color && colorTally(list).indexOf(st.color) < 0) st.color = '';
    }
    sizes.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-v]'); if (!b || b.dataset.v === st.band) return;
      st.band = b.dataset.v;   // '' = All sizes
      dropStaleFilters();
      filtered('size', st.band || 'all');
    });
    forms.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-v]'); if (!b) return;
      if (DECOR) {   // category switch: same feed, no load
        if (b.dataset.v === st.cat) return;
        st.cat = b.dataset.v;
        dropStaleFilters();
        filtered('category', st.cat);
        return;
      }
      if (b.dataset.v === st.form) return;
      var next = b.dataset.v;
      ui.panel.setAttribute('aria-busy', 'true');
      load(next).then(function () {
        st.form = next; data = feeds[next];
        var have = bands();
        if (st.band && have.indexOf(st.band) < 0) st.band = have[0] || '';
        dropStaleFilters();
        ui.panel.setAttribute('aria-busy', 'false');
        filtered('form', next);
      }).catch(function () {
        ui.panel.setAttribute('aria-busy', 'false');
        ui.count.textContent = 'Those did not load. Please try again.';
      });
    });
    grid.addEventListener('click', onGridClick);
    if (SET_ON) {
      slots.addEventListener('click', function (e) {
        var bagBtn = e.target.closest('button[data-bag]');
        if (bagBtn) { removeFromBag(bag.items[+bagBtn.dataset.bag]); ui.body.focus({ preventScroll: true }); return; }
        var b = e.target.closest('button[data-h]'); if (!b) return;
        toggleSet(b.dataset.h); (ui.slots.querySelector('button') || ui.body).focus();
      });
      cta.addEventListener('click', addSet);
    }
  }

  /* ---- one Tab stop per filter row ---- */
  function rove(e) {
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: 'first', End: 'last' };
    var move = keys[e.key];
    if (!move) return;
    var btns = Array.prototype.slice.call(e.currentTarget.querySelectorAll('button'));
    var at = btns.indexOf(document.activeElement);
    if (at < 0) return;
    e.preventDefault();
    var to = move === 'first' ? 0 : move === 'last' ? btns.length - 1 : (at + move + btns.length) % btns.length;
    btns.forEach(function (b, i) { b.tabIndex = i === to ? 0 : -1; });
    btns[to].focus();
  }
  function setRoving(group) {
    var btns = group.querySelectorAll('button');
    var on = group.querySelector('button[aria-pressed="true"]') || btns[0];
    Array.prototype.forEach.call(btns, function (b) { b.tabIndex = b === on ? 0 : -1; });
  }

  /* ---- rendering ---- */
  function chipBtn(label, value, on) {
    return el('button', { type: 'button', class: 'bbsw__chip', 'data-v': value, 'aria-pressed': on ? 'true' : 'false', text: label });
  }
  function label(it) {
    // what the tile shows, so two stones with the same name do not sound the same
    if (MODE === 'similar') return [it.t || it.n, it.s, it.w, it.pf].filter(Boolean).join(', ');
    return [cleanName(it), gradeText(it.g), it.r || it.c].filter(Boolean).join(', ');
  }
  function renderControls() {
    var list = inBand();
    if (MODE === 'similar') {
      ui.sub.textContent = [cfg.name, 'one of one', list.length + ' available'].filter(Boolean).join(' \u00b7 ');
      return;
    }
    var span = bucketSpan(st.band);
    ui.sub.textContent = DECOR
      ? [formLabel(), list.length + ' in stock'].join(' \u00b7 ')
      : [formLabel(), st.band ? bucketLabel(st.band) + (span ? ' (' + span + ')' : '') : 'All sizes', list.length + ' in stock'].filter(Boolean).join(' \u00b7 ');

    // form chips: the bulk forms, or on a decor page the decor categories that have stock
    ui.forms.textContent = '';
    if (DECOR) {
      // a diffuser page shows diffusers, a heart page hearts: the category is fixed (Paul, 14 Oct 2026)
    } else if (false) {   // form chips retired 14 Oct 2026 (Paul: keep the drawer to this collection)
      FORMS.forEach(function (f) {
        var b = chipBtn(FORM_CHIP[f] || f, f, st.form === f);
        b.className = 'bbsw__chip bbsw__chip--form';
        ui.forms.appendChild(b);
      });
    }
    ui.forms.hidden = !ui.forms.childNodes.length;
    setRoving(ui.forms);

    // size groups present in this form, Mini to Extra Large, each with its inch span
    var all = bands();
    ui.sizes.textContent = '';
    if (all.length > 1) {
      ui.sizes.appendChild(el('button', { type: 'button', class: 'bbsw__size', 'data-v': '', 'aria-pressed': st.band ? 'false' : 'true', 'aria-label': 'All sizes' }, [el('b', { text: 'All sizes' })]));
      all.forEach(function (k) {
        var sp = bucketSpan(k);
        var b = el('button', { type: 'button', class: 'bbsw__size', 'data-v': k, 'aria-pressed': st.band === k ? 'true' : 'false', 'aria-label': bucketLabel(k) + (sp ? ', ' + sp : '') }, [
          el('b', { text: bucketLabel(k) }), sp ? el('small', { text: sp }) : null
        ]);
        ui.sizes.appendChild(b);
      });
      ui.sizes.hidden = false;
    } else ui.sizes.hidden = true;
    setRoving(ui.sizes);

    // intention chips: only those present in this size, most common first
    // the seven most common intentions, the rest behind "+ N more" so the pieces stay above the fold
    var intents = tally(list, 'i');
    var MAXI = 7;
    var showAll = st.moreIntents || (st.intent && intents.indexOf(st.intent) >= MAXI);
    ui.chips.textContent = '';
    ui.chips.classList.toggle('is-open', !!showAll);
    if (intents.length) {
      ui.chips.appendChild(chipBtn('All intentions', '', !st.intent));
      intents.forEach(function (v, i) { if (showAll || i < MAXI) ui.chips.appendChild(chipBtn(v, v, st.intent === v)); });
      if (intents.length > MAXI) {
        ui.chips.appendChild(el('button', { type: 'button', class: 'bbsw__chip bbsw__chip--more', 'data-more': '1', 'aria-expanded': showAll ? 'true' : 'false', text: showAll ? 'Fewer' : '+ ' + (intents.length - MAXI) + ' more' }));
      }
    }
    ui.chips.hidden = !intents.length;
    setRoving(ui.chips);

    // color swatches: 14 families, in a fixed order
    var colors = colorTally(list);
    ui.dots.textContent = '';
    if (colors.length) {   // "All colors" leads the dots, the way "All intentions" leads the chips (Paul, 14 Oct 2026)
      var allc = chipBtn('All colors', '', !st.color);
      allc.className = 'bbsw__chip bbsw__chip--all';
      ui.dots.appendChild(allc);
    }
    colors.forEach(function (v) {
      var hex = FAMILY_HEX[v];
      if (!hex) return;
      var b = el('button', { type: 'button', class: 'bbsw__dot', 'data-v': v, 'aria-pressed': st.color === v ? 'true' : 'false', 'aria-label': v, title: v });
      b.appendChild(el('span', { style: 'background:' + hex }));
      ui.dots.appendChild(b);
    });
    ui.dots.hidden = !ui.dots.childNodes.length;
    setRoving(ui.dots);
  }
  function tile(it, pos) {
    var viewing = it.h === HANDLE;
    var name = MODE === 'similar' ? (it.t || it.n || '') : cleanName(it);
    // WebKit starts the download as soon as src is set, so loading, sizes and srcset come first and src last
    var img = it.img ? el('img', {
      loading: pos < 4 ? 'eager' : 'lazy', decoding: 'async', alt: '', width: '300', height: '300',
      sizes: '(min-width: 768px) 170px, 44vw',
      srcset: imgAt(it.img, 300) + ' 300w, ' + imgAt(it.img, 450) + ' 450w, ' + imgAt(it.img, 600) + ' 600w',
      src: imgAt(it.img, 300)
    }) : null;
    var link = el('a', { class: 'bbsw__link', href: ROOT + 'products/' + it.h, 'data-pos': String(pos + 1), 'aria-describedby': 'bbsw-m' + pos }, [
      el('span', { class: 'bbsw__img' }, [img]),
      viewing ? el('span', { class: 'bbsw__ey', text: 'Viewing now' }) : null,
      el('span', { class: 'bbsw__name', text: name })
    ]);
    var kids = [link];
    if (MODE === 'similar') {
      var dims = [it.s, it.w].filter(Boolean).join(' \u00b7 ');
      kids.push(el('div', { class: 'bbsw__meta', id: 'bbsw-m' + pos, text: dims }));
      kids.push(el('div', { class: 'bbsw__price', text: it.pf || money(it.p, data.cur) }));
    } else {
      // the same facts as a product card: grade and size, then region and country
      var spec = [gradeText(it.g), sizeText(it.s)].filter(Boolean).join(' \u00a0|\u00a0 ');
      var origin = it.r || it.c || '';
      var wt = weightText(it.w);
      kids.push(el('div', { class: 'bbsw__meta', id: 'bbsw-m' + pos }, [
        spec ? el('span', { class: 'bbsw__spec', text: spec }) : null,
        origin ? el('span', { class: 'bbsw__origin', text: origin }) : null,
        wt ? el('span', { class: 'bbsw__w' }, [weightIcon(), document.createTextNode(wt)]) : null
      ]));
      if ((it.i || []).length) kids.push(el('div', { class: 'bbsw__int', text: it.i.slice(0, 3).join(' \u00b7 ') }));
      // one-of-one pieces show a plain price; "a piece" only where a set can be built
      kids.push(el('div', { class: 'bbsw__price', text: (it.e ? '' : 'from ') + (it.pf || money(it.p, data.cur)) + (SET_ON && it.v ? ' a ' + nounOf()[0] : '') }));
      if (SET_ON && it.v) {
        var inSet = st.set.indexOf(it.h) > -1;
        kids.push(el('button', {
          type: 'button', class: 'bbsw__add' + (inSet ? ' is-in' : ''), 'data-h': it.h,
          'aria-label': addLabel(it, inSet),
          text: inSet ? 'In your set' : 'Add to set'
        }));
      }
    }
    return el('li', { class: 'bbsw__tile' + (viewing ? ' is-now' : ''), 'data-h': it.h }, kids);
  }
  function addLabel(it, inSet) {
    // starts with the words on the button, then says which stone
    return (inSet ? 'In your set: ' + label(it) + '. Remove' : 'Add to set: ' + label(it));
  }
  function renderGrid() {
    var list = visible();
    var on = !!(st.intent || st.color || st.q);
    var chosen = [st.intent, st.color, st.q ? '\u201c' + st.q + '\u201d' : ''].filter(Boolean).join(' \u00b7 ');     // the filters in words, not color alone
    var none = MODE === 'similar' ? 'No other ' + (cfg.name ? cfg.name + ' ' : '') + 'pieces right now.' : (DECOR ? 'Nothing else in this category right now.' : 'Nothing else in this size right now. Try another size or form.');
    ui.count.textContent = list.length ? plural(list.length) + (chosen ? ' \u00b7 ' + chosen : '') : (on ? 'No ' + nounOf()[1] + ' match ' + chosen + '.' : none);
    ui.clear.hidden = !on;
    var frag = document.createDocumentFragment();
    list.forEach(function (it, i) { frag.appendChild(tile(it, i)); });
    ui.grid.textContent = '';
    ui.grid.appendChild(frag);
    ui.body.scrollTop = 0;
    return list.length;
  }
  function renderSet() {
    if (!SET_ON) return;
    var sellsSingles = data.items.some(function (it) { return !!it.v; }) || st.set.length > 0 || bag.n > 0;
    ui.setBar.hidden = !sellsSingles;
    if (!sellsSingles) return;
    var picked = st.set.map(function (h) { return catalog[h]; }).filter(Boolean);
    var k = picked.length, n = bag.n + k;
    // thumbnails: what is already in the bag first (not removable here), then the new picks (tap to remove)
    ui.slots.textContent = '';
    bag.items.forEach(function (b, idx) {
      var s = el('button', { type: 'button', class: 'bbsw__slot bbsw__slot--bag', 'data-bag': String(idx), title: b.n + ' \u00b7 in your bag \u00b7 tap to remove', 'aria-label': 'Remove ' + b.n + ' from your bag' });
      if (b.img) s.appendChild(el('img', { src: imgAt(b.img, 120), alt: '', width: '32', height: '32' }));
      if (b.q > 1) s.appendChild(el('i', { class: 'bbsw__slot-q', text: '×' + b.q }));
      ui.slots.appendChild(s);
    });
    picked.forEach(function (it) {
      var b = el('button', { type: 'button', class: 'bbsw__slot is-full', 'data-h': it.h, title: 'Remove ' + label(it), 'aria-label': 'Remove ' + label(it) + ' from your set' });
      if (it.img) b.appendChild(el('img', { src: imgAt(it.img, 120), alt: '', width: '40', height: '40' }));
      b.appendChild(el('span', { class: 'bbsw__slot-x', 'aria-hidden': 'true', text: '×' }));
      ui.slots.appendChild(b);
    });
    ui.slots.hidden = n === 0;
    var tier = TIERS_LIVE ? tierFor(n) : null, next = TIERS_LIVE ? nextTier(n) : null;
    var pct = tier ? tier[1] : 0;
    var picksTotal = picked.reduce(function (sum, it) { return sum + it.p; }, 0);
    var offPicks = Math.round(picksTotal * pct / 100);
    var offAll = Math.round((picksTotal + bag.total) * pct / 100);
    var pay = picksTotal - offPicks;
    // the ladder fills segment by segment, so 3 of 6 reads as half way to the next rung
    if (ui.lfill) {
      var fill = 0;
      for (var i = 0; i < TIERS.length; i++) {
        var lo = i ? TIERS[i - 1][0] : 0, hi = TIERS[i][0];
        if (n >= hi) { fill = (i + 1) / TIERS.length; continue; }
        fill = (i + (n - lo) / (hi - lo)) / TIERS.length; break;
      }
      ui.lfill.style.width = (Math.min(1, fill) * 100).toFixed(1) + '%';
      ui.lnodes.forEach(function (node, j) { node.classList.toggle('is-hit', n >= TIERS[j][0]); });
    }
    var cur = data.cur;
    if (!n) {
      ui.setTitle.textContent = 'Build a set';
      ui.setSub.textContent = TIERS_LIVE ? 'Any ' + TIERS[0][0] + ' single pieces, ' + TIERS[0][1] + '% off. Mix stones, sizes and forms.' : 'Pick any pieces and add them to your bag in one go';
    } else if (!k) {
      ui.setTitle.textContent = bag.n + ' in your bag' + (tier ? ' · ' + pct + '% off' : '');
      ui.setSub.textContent = next ? 'Add ' + (next[0] - n) + ' more for ' + next[1] + '% off' : 'Top tier reached on every single piece';
    } else {
      ui.setTitle.textContent = plural(n) + (tier ? ' · save ' + money(offAll, cur) : ' · ' + money(picksTotal, cur));
      var parts = [];
      if (bag.n) parts.push(bag.n + ' in bag + ' + k + ' new');
      if (tier) parts.push(pct + '% off');
      if (next) parts.push((next[0] - n) + ' more for ' + next[1] + '% off');
      ui.setSub.textContent = parts.join(' \u00b7 ');
    }
    ui.setBar.classList.toggle('is-empty', n === 0);
    ui.cta.textContent = k ? 'Add ' + k + ' to bag' + (tier ? ' · ' + money(pay, cur) : '') : 'Pick pieces to add';
    ui.cta.disabled = k === 0;
    ui.setBar.classList.toggle('is-ready', !!tier);
    slotsOver();
    // keep the tiles in step
    ui.grid.querySelectorAll('.bbsw__add').forEach(function (btn) {
      var inSet = st.set.indexOf(btn.dataset.h) > -1;
      var inBag = !inSet && !!bagByHandle()[btn.dataset.h];
      var it2 = catalog[btn.dataset.h] || {};
      btn.classList.toggle('is-in', inSet);
      btn.classList.toggle('is-bag', inBag);
      btn.textContent = inSet ? 'In your set' : (inBag ? 'In your bag' : 'Add to set');
      btn.setAttribute('aria-label', inBag ? 'In your bag: ' + label(it2) + '. Remove from bag' : addLabel(it2, inSet));
    });
  }
  // a fade on the right edge of the slot strip while more pieces sit out of view
  function slotsOver() {
    if (!ui || !ui.slots) return;
    requestAnimationFrame(function () {
      var more = ui.slots.scrollWidth - ui.slots.clientWidth - ui.slots.scrollLeft > 2;
      ui.slots.classList.toggle('is-over', more);
    });
  }
  function tierFor(n) { var t = null; TIERS.forEach(function (x) { if (n >= x[0]) t = x; }); return t; }
  function nextTier(n) { for (var i = 0; i < TIERS.length; i++) if (n < TIERS[i][0]) return TIERS[i]; return null; }
  function activeFilter() {
    if (st.intent) return ['intention', st.intent];
    if (st.color) return ['color', st.color];
    if (DECOR && st.cat !== KIND) return ['category', st.cat];
    if (MODE === 'swap' && st.form !== FORM) return ['form', st.form];
    if (MODE === 'swap' && st.band) return ['size', st.band];
    return ['', ''];
  }
  function filtered(type, value) {
    // the controls are rebuilt, so remember which one had focus and hand it back
    var act = document.activeElement;
    var group = act && act.closest ? act.closest('.bbsw__chips, .bbsw__dots') : null;
    var was = group ? act.getAttribute('data-v') : null;
    renderControls();
    var n = renderGrid();
    renderSet();
    if (group) {
      var again = Array.prototype.filter.call(group.querySelectorAll('button'), function (b) { return b.getAttribute('data-v') === was; })[0];
      (again || ui.body).focus({ preventScroll: true });
    }
    window.bbTrack('bb_swap_filter', base({ filter_type: type, filter_value: value, result_count: n }));
  }
  function base(extra) {
    return Object.assign({
      product_handle: HANDLE, crystal_form: formTag(),
      size_band: MODE === 'similar' ? '' : st.band, ui_source: st.source
    }, extra || {});
  }

  /* ---- set builder ---- */
  function toggleSet(h) {
    var at = st.set.indexOf(h);
    var it = catalog[h] || {};
    var did = '';
    if (at > -1) { st.set.splice(at, 1); did = ' removed. '; }
    else { st.set.push(h); did = ' added. '; }
    ui.err.hidden = true;
    renderSet();
    saveSet();
    if (at < 0) ui.slots.scrollLeft = ui.slots.scrollWidth;   // the newest piece stays in view
    if (did) {
      var n = totalN(), next = TIERS_LIVE ? nextTier(n) : null, tier = TIERS_LIVE ? tierFor(n) : null;
      ui.live.textContent = (cleanName(it) || it.n || '') + did + n + ' in your set' + (bag.n ? ' counting your bag' : '') + '.' + (tier ? ' ' + tier[1] + '% off.' : '') + (next ? ' ' + (next[0] - n) + ' more for ' + next[1] + '% off.' : '');
    }
  }
  function bagByHandle() { var m = {}; bag.items.forEach(function (b) { if (b.h && !m[b.h]) m[b.h] = b; }); return m; }
  // Takes one of a bag line out (15 Oct 2026, Paul: pieces already in the bag showed a check and could not be removed
  // from the drawer). Re-renders the bag drawer from the response sections, then cart:updated re-reads the bag here.
  var removing = false;
  function removeFromBag(b) {
    if (!b || !b.key || removing) return;
    removing = true;
    var cart = document.querySelector('cart-drawer');
    var payload = { id: b.key, quantity: Math.max(0, b.q - 1) };
    try {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (sec) { return sec.id; });
        payload.sections_url = location.pathname;
      }
    } catch (e) {}
    if (ui.err) ui.err.hidden = true;
    fetch((window.routes && window.routes.cart_change_url) || '/cart/change', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        removing = false;
        if (res && res.sections && cart && typeof cart.getSectionInnerHTML === 'function') {
          cart.getSectionsToRender().forEach(function (sec) {
            if (!res.sections[sec.id]) return;
            Array.prototype.forEach.call(document.querySelectorAll(sec.selector), function (node) {
              try { node.innerHTML = cart.getSectionInnerHTML(res.sections[sec.id], sec.selector); } catch (e) {}
            });
          });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'bb-swap' } }));
        if (ui.live) ui.live.textContent = b.n + ' removed from your bag.';
        window.bbTrack('bb_set_bag_remove', base({ removed_handle: b.h }));
      }).catch(function () {
        removing = false;
        if (ui.err) { ui.err.textContent = 'That did not go through. Please try again.'; ui.err.hidden = false; }
      });
  }
  function addSet() {
    if (!st.set.length || ui.cta.getAttribute('aria-busy') === 'true') return;
    var picked = st.set.map(function (h) { return catalog[h]; }).filter(Boolean);
    var cart = document.querySelector('cart-drawer');
    var payload = { items: picked.map(function (it) { return { id: +it.v, quantity: 1 }; }) };
    try {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (sec) { return sec.id; });
        payload.sections_url = location.pathname;
      }
    } catch (e) {}
    ui.cta.setAttribute('aria-busy', 'true');
    ui.err.hidden = true;
    function fail(msg) {
      ui.cta.removeAttribute('aria-busy');
      ui.err.textContent = msg || (window.cartStrings && window.cartStrings.error) || 'That did not go through. Please try again.';
      ui.err.hidden = false;
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          fail(res.j && res.j.description);
          refreshBag();   // a refused add can still have put something in the bag, so show the truth
          return;
        }
        ui.cta.removeAttribute('aria-busy');
        window.bbTrack('bb_set_add', base({
          set_size: picked.length, set_items: picked.map(function (it) { return it.n; }).join(', '),
          value: picked.reduce(function (n, it) { return n + it.p; }, 0) / 100, currency: data.cur
        }));
        st.set = [];
        saveSet();
        renderSet();
        shut(function () { showCart(res.j); });
      }).catch(function () { fail(''); });
  }
  function showCart(response) {
    var cart = document.querySelector('cart-drawer');
    if (cart && typeof cart.renderContents === 'function' && response && response.sections) {
      try {
        cart.classList.remove('is-empty');
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(trig());   // focus returns here when the bag closes
        // The theme's own focus move misses after a re-render (it holds a stale node), so hand focus over here.
        document.addEventListener('cart-drawer:open', function once() {
          document.removeEventListener('cart-drawer:open', once);
          setTimeout(function () {
            var inner = document.querySelector('#CartDrawer .drawer__inner');
            if (inner && typeof window.trapFocus === 'function') window.trapFocus(cart, inner);
          }, 30);
        });
        cart.renderContents(response);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'bb-swap' } }));
        return;
      } catch (e) {}
    }
    location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  function refreshBag() {
    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.getSectionsToRender !== 'function' || typeof cart.getSectionInnerHTML !== 'function') return;
    var list = cart.getSectionsToRender();
    fetch(location.pathname + '?sections=' + list.map(function (sec) { return sec.id; }).join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        list.forEach(function (sec) {
          if (!sections[sec.id]) return;
          Array.prototype.forEach.call(document.querySelectorAll(sec.selector), function (node) {
            try { node.innerHTML = cart.getSectionInnerHTML(sections[sec.id], sec.selector); } catch (e) {}
          });
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'bb-swap' } }));
      }).catch(function () {});
  }

  /* ---- tile clicks ---- */
  function onGridClick(e) {
    var add = e.target.closest('.bbsw__add');
    if (add) {
      // a piece already in the bag (and not a new pick) toggles out of the bag, the same way "In your set" toggles out of the set
      var inBagItem = st.set.indexOf(add.dataset.h) < 0 ? bagByHandle()[add.dataset.h] : null;
      if (inBagItem) removeFromBag(inBagItem); else toggleSet(add.dataset.h);
      return;
    }
    var a = e.target.closest('a.bbsw__link');
    if (!a) return;
    var li = a.closest('li');
    if (li.dataset.h === HANDLE) { e.preventDefault(); shut(); return; }   // already here
    var af = activeFilter();
    try {
      sessionStorage.setItem(NAV_KEY, JSON.stringify({
        to: li.dataset.h, from: HANDLE, pos: +a.dataset.pos, form: formTag(),
        band: MODE === 'similar' ? '' : st.band, src: st.source, ft: af[0], fv: af[1], t: Date.now()
      }));
    } catch (err) {}
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;   // new tab or window: leave it to the browser
    // replace our pushed history entry, so Back from the next product returns to this one with the drawer closed
    if (pushed) { e.preventDefault(); pushed = false; location.replace(a.href); }
  }

  /* ---- open and close ---- */
  var cssReady = null;
  function loadCss() {
    if (cssReady) return cssReady;
    cssReady = new Promise(function (resolve, reject) {
      if (!cfg.css) return resolve();
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = cfg.css;
      var timer = setTimeout(function () { reject(new Error('css timeout')); }, 10000);
      l.onload = function () { clearTimeout(timer); resolve(); };
      l.onerror = function () { clearTimeout(timer); reject(new Error('css failed')); };
      document.head.appendChild(l);
    }).catch(function (e) { cssReady = null; throw e; });   // a later tap can try again
    return cssReady;
  }
  function fallbackPage() { location.href = (cfg.feed || '').replace(/section_id=bb-swap-feed&?/, ''); }
  function lockScroll(on) {
    var root = document.documentElement;
    if (on) {
      var gap = window.innerWidth - root.clientWidth;
      root.style.setProperty('--bbsw-gap', gap + 'px');
      root.classList.add('bbsw-open');
    } else root.classList.remove('bbsw-open');
  }
  // The panel's geometry is also written inline so the very first paint cannot show an unstyled,
  // full-width panel at the left before assets/bb-swap.css applies (seen by Paul, 15 Oct 2026).
  function criticalCss() {
    if (document.getElementById('bbsw-crit')) return;
    var s = document.createElement('style');
    s.id = 'bbsw-crit';
    s.textContent = '.bbsw{position:fixed;inset:0;width:100%;height:100%;max-width:none;max-height:none;margin:0;padding:0;border:0;background:transparent;overflow:clip}' +
      '.bbsw:not([open]){display:none}.bbsw__panel{position:absolute;left:0;right:0;bottom:0;height:92vh;height:92dvh;transform:translateY(100%)}' +
      '@media(min-width:768px){.bbsw__panel{top:0;left:auto;width:600px;max-width:100%;height:100%;transform:translateX(100%)}}' +
      '.bbsw.is-in .bbsw__panel{transform:none}';
    document.head.appendChild(s);
  }
  function open(source, opener) {
    if (ui && ui.dlg.open) return;
    lastFocus = opener || trig();
    st.source = source || (MODE === 'similar' ? 'similar_button' : 'swap_button');
    if (opening) return;
    opening = true;
    loadCss().then(function () {
      opening = false;
      criticalCss();
      if (!ui) build();
      if (ui.dlg.open) return;
      ui.dlg.classList.remove('is-in', 'is-out');
      ui.panel.setAttribute('aria-busy', data ? 'false' : 'true');
      if (!data) ui.sub.textContent = 'Loading\u2026';
      if (ui.err) { ui.err.hidden = true; ui.err.textContent = ''; }
      if (ui.live) ui.live.textContent = '';
      var ticket = ++opens;
      lockScroll(true);
      if (SET_ON) loadBag(function () { if (ui && data && ui.dlg.open) renderSet(); });
      if (typeof ui.dlg.showModal === 'function') ui.dlg.showModal(); else ui.dlg.setAttribute('open', '');
      settled = false;
      ui.dlg.classList.add('is-opening');
      setTimeout(function () { settled = true; ui.dlg.classList.remove('is-opening'); }, 350);
      ui.dlg.scrollLeft = 0; ui.dlg.scrollTop = 0;
      requestAnimationFrame(function () { requestAnimationFrame(function () { ui.dlg.classList.add('is-in'); ui.dlg.scrollLeft = 0; ui.dlg.scrollTop = 0; }); });
      ui.close.focus({ preventScroll: true });
      try { history.pushState({ bbSwap: 1 }, ''); pushed = true; } catch (e) {}
      load().then(function () {
        ui.panel.setAttribute('aria-busy', 'false');
        renderControls();
        renderGrid();
        renderSet();
        if (ticket === opens && ui.dlg.open) window.bbTrack('bb_swap_open', base({ sibling_count: inBand().length }));
      }).catch(function () {
        ui.panel.setAttribute('aria-busy', 'false');
        ui.sub.textContent = '';
        ui.count.textContent = 'These did not load. Close this and try again.';
      });
    }).catch(function () { opening = false; fallbackPage(); });   // no stylesheet: the filtered collection page instead of a bare list
  }
  function shut(after, fromPop) {
    if (!ui || !ui.dlg.open) { if (after) after(); return; }
    var done = false;
    function finish() {
      if (done) return; done = true;
      ui.dlg.classList.remove('is-in', 'is-out');
      if (typeof ui.dlg.close === 'function') ui.dlg.close(); else ui.dlg.removeAttribute('open');
      lockScroll(false);
      if (!after && lastFocus && document.contains(lastFocus)) lastFocus.focus();
      if (after) after();
    }
    if (pushed && !fromPop) { pushed = false; try { if (history.state && history.state.bbSwap) history.back(); } catch (e) {} }
    else if (fromPop) pushed = false;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still) return finish();
    ui.dlg.classList.remove('is-in');
    ui.dlg.classList.add('is-out');
    ui.panel.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 320);
  }
  window.addEventListener('popstate', function () { if (ui && ui.dlg.open && pushed) shut(null, true); });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && ui && ui.dlg.open) { ui.dlg.classList.remove('is-in', 'is-out'); ui.dlg.close(); lockScroll(false); pushed = false; }
  });

  // One delegated listener: the button itself, and any other opener such as a "Build a set" link
  // (<a data-bb-swap-open="build_set_link">). Delegation also survives the theme editor re-rendering the section.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-bb-swap]')) { open(); return; }
    var o = e.target.closest('[data-bb-swap-open]');
    if (!o) return;
    e.preventDefault();
    open(o.getAttribute('data-bb-swap-open') || undefined, o);
  });
  // warm the stylesheet when the shopper shows intent, so the first open does not wait on it
  ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest('[data-bb-swap], [data-bb-swap-open]')) loadCss(); }, { passive: true });
  });
})();
